import { default as ReactDatePicker } from 'react-datepicker'

export const DatePicker = ReactDatePicker
